module.exports = __webpack_public_path__ + "img/YE.1a89616e.svg";